import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

export default class Portal extends React.Component {

	static propTypes = {
		portalId: PropTypes.string,
		className: PropTypes.string,
		portalRef: PropTypes.func,
		target: PropTypes.any,
		onClick: PropTypes.func,
		onMouseDown: PropTypes.func,
		onMouseUp: PropTypes.func,
		zIndex: PropTypes.number,
		style: PropTypes.object,
	};

	static defaultProps = {
		zIndex: 9000,
		portalId: 'ui-portal',
	};

	componentDidMount() {
		this.element = this.props.portalId && document.getElementById(this.props.portalId);
		if (!this.element) {
			this.element = document.createElement('div');
			this.element.id = this.props.portalId;
			if (this.props.onClick) this.element.onclick = this.props.onClick;
			if (this.props.onMouseDown) this.element.onmousedown = this.props.onMouseDown;
			if (this.props.onMouseUp) this.element.onmouseup = this.props.onMouseUp;
			if (this.props.className) this.element.className = this.props.className;
			if (this.props.zIndex) this.element.style.setProperty('z-index', this.props.zIndex);
			if (this.props.style) {
				Object.keys(this.props.style).forEach(key => this.element.style.setProperty(key, this.props.style[key]));
				console.log('this.element.style', this.props.style, this.element.style);
			}
			const target = this.props.target || document.getElementById('app-container') || document.body;
			target.appendChild(this.element);
		}
		this.portalElement = this.element;
		if (this.props.getRef) this.props.getRef(this.portalElement);
		this.renderContent(this.props);
	}

	componentWillUnmount() {
		this.portalElement.remove();
		// document.getElementById('app-container').removeChild(this.portalElement);
	}

	componentDidUpdate() {
		// console.log('componentWillReceiveProps', nextProps.className, this.element);
		if (this.element) {
			this.element.onClick = this.props.onClick;
			this.element.className = this.props.className || '';
		}
		this.renderContent(this.props);
	}

	renderContent(props) {
		ReactDOM.render(<React.Fragment>{props.children}</React.Fragment>, this.portalElement);
	}

	render() {
		return null;
	}

}
